import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { LegacyDialogComponent } from './legacy-dialog.component';



@NgModule({
  declarations: [
    LegacyDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule
  ],
  exports: [
    LegacyDialogComponent
  ],
  entryComponents: [
    LegacyDialogComponent
  ]
})
export class LegacyDialogModule { }
